import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6616b458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-table-cell-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, key) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent(action, key)), _mergeProps({ key: key }, _ctx.getProps(action, key), {
        class: "oxd-table-cell-action-space",
        disabled: _ctx.isDisabled,
        onClick: ($event: any) => (_ctx.onClickAction(action, key, $event))
      }), null, 16, ["disabled", "onClick"]))
    }), 128))
  ]))
}